import React, {useState, useEffect, useRef,useCallback } from "react";
import { useLocation } from "react-router-dom";
import Grid from "@mui/material/Grid";
import {
    Typography,
    useMediaQuery,
    useTheme,
    Box,
    Button,
    Modal,
    CircularProgress,
    TextField,
    Container,
    IconButton
} from "@mui/material";
import RefreshIcon from '@mui/icons-material/Refresh';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MissionLogStyles from "../../styles/MissionLog.module.css";
import {
    ackInvalidCancelAuthorization,
    ackRescindAuthorization,
    cancelAuthorization,
    deleteAuthorization,
    getOperations,
} from "../../network/apis/missionlog.api";
import {useAuth} from "../../context/authContext";
import {useProfile} from "../../context/userContext";
import {useOrganization} from "../../context/OrganizationContext";
import PopupAlert from "../../components/PopupAlert";
import { OperationCardComponent } from "./operationSection/Operations";
import { MoreDetailsComponent } from "./operationSection/OperationDetails";
import MissionLogFilter from "./filterSection/FilterSection";
import { abortMultipartUpload, checkFileNameExists, checkStorageAvailability, completeMultipartUpload, deleteFile, generatePresignUrl, getAllFiles, getDownloadUrl, saveFileMetadata, shareFile } from "../../network/apis/file.api";
import {
    checkOrganizationStorageAvailability,
    generateOrganizationPresignUrl,
    completeOrganizationMultipartUpload,
    abortOrganizationMultipartUpload,
    getAllOrganizationFiles,
    getOrganizationDownloadUrl,
    deleteOrganizationFile,
    checkOrganizationFileNameExists
} from "../../network/apis/organizationFile.api";
import axiosInstance from "../../network/axiosClient";
import axios from "axios";
import { useUpload } from "../../context/uploadContext";
import SharedHistoryModal from "./fileSection/fileSharedHistory";
import ShareModal from "./fileSection/ShareModal";
import DefaultBackground from "../../assests/public_page_bg.jpg";
import DefaultLogo from "../../assests/flyzone_by_flightloop.png";
import { saveUploadsDB, generatePresignedUrlsForCustomizationAssests, getShareAssetUrls } from "../../network/apis/customization.api";
import ConfirmationModal from "../../components/ConfirmationModal";
import CreateTemplateDialog from "../../components/CreateTemplateDialog";
import LogFlightDialog from "../../components/fleet/LogFlightDialog";
import MapViewDialog from "../../components/MapViewDialog";
import { addFlightLog, updateFlightLog, deleteFlightLog } from "../../network/apis/flightLog.api";
import { hasPermission, PERMISSIONS } from "../../utils/permissions";
import logger from "../../utils/logger";

const MissionLog = ({onFileUpload }) => {
    const {authenticated,token} = useAuth();
    const {profile, error} = useProfile();
    const { currentOrganization, isInOrganizationMode, userRole, organizationMembers, loading: contextLoading, subscriptionStatus } = useOrganization();
    const userId = profile?.userId;
    const location = useLocation();
    const highlightOperationId = location.state?.highlightOperationId ?? null;
    const [alert, setAlert] = useState({
        open: false,
        message: '',
        title: '',
        buttonText: ''
    });
    const { uploadState, setUploadState } = useUpload();
    const {
        file,
        uploading,
        uploadProgress,
        message,
        showPanel,
        failedUploads
    } = uploadState;
    const [open, setOpen] = useState(false);
    const [page, setPage] = useState(1);
    const fileInputRef = useRef(null);
    const [selectedOperation, setSelectedOperation] = useState(null);
    const [selectedAuthorizationId, setSelectedAuthorizationId] = useState(null);
    const [displayedOperations, setDisplayedOperations] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [openRescindModal, setOpenRescindModal] = useState(false);
    const [openInvalidModal, setOpenInvalidModal] = useState(false);
    const [openShareModal, setOpenShareModal] = useState(false);
    const [createTemplateDialogOpen, setCreateTemplateDialogOpen] = useState(false);
    const [logFlightDialogOpen, setLogFlightDialogOpen] = useState(false);
    const [editingFlightLog, setEditingFlightLog] = useState(null);
    const [deleteFlightLogModal, setDeleteFlightLogModal] = useState(false);
    const [flightLogToDelete, setFlightLogToDelete] = useState(null);
    const [mapViewDialogOpen, setMapViewDialogOpen] = useState(false);
    const [mapViewOperation, setMapViewOperation] = useState(null);
    const [drones, setDrones] = useState([]);
    const scrollContainerRef = useRef();
    const isLoadingMoreRef = useRef(false); // Prevent multiple simultaneous page loads
    const isInitialMount = useRef(true); // Track initial mount to prevent duplicate loads
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [showMobileDetail, setShowMobileDetail] = useState(false);
    const operationsPerPage = isSmallScreen ? 5 : 12;
    const [loading, setLoading] = useState(false);
    const [refresh, setRefreshing] = useState(false);
    const [hasMoreOperations, setHasMoreOperations] = useState(true);
    const [startDate1, setStartDate1] = useState(null);
    const [startDate2, setStartDate2] = useState(null);
    const [filters, setFilters] = useState({});
    const [sortOrder, setSortOrder] = useState("desc");
    // Default to all statuses to show all operations
    const [statusFilter, setStatusFilter] = useState(['Authorized', 'Pending', 'Complete', 'De-authorized', 'Deleted', 'Never Authorized', 'Invalid Detected', 'Rescinded Awaiting']);
    const [userModifiedFilter, setUserModifiedFilter] = useState(false); // Track if user manually changed filter
    const [includeNoAuths, setIncludeNoAuths] = useState(true); // Include operations without authorizations by default
    const [files, setFiles] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [shareEmail, setShareEmail] = useState('');
    const [recipientName ,setRecipientName] =useState('');
    const [shareLoading, setShareLoading] = useState(false);
    const [backgroundImage, setBackgroundImage] = useState('');
    const [logoImage, setLogoImage] = useState('');
    const[logoImageFile,setLogoImageFile] = useState(null);
    const [backgroundImageFile,setBackgroundImageFile] = useState(null);
    const [existingBackground, setExistingBackground] = useState(null);
    const [existingLogo, setExistingLogo] = useState(null);
    const subscriptionType = profile?.subscription?.id;
    const [usedStorage, setUsedStorage] = useState(null);
    const[totalStorage,setTotalStorage] = useState(null);
    const [hasStorage, setStorage] = useState(false);
    const bytesToGB = (bytes) => {return parseFloat((bytes / (1024 * 1024 * 1024)).toFixed(2))};
    const bytesToMB = (bytes) => {return parseFloat((bytes / (1024 * 1024)).toFixed(2))};
    const [modalVisible, setModalVisible] = useState(false);

    // Check if subscription is valid (active, trialing, or past_due for grace period)
    const isValidSubscription = subscriptionStatus === 'active' ||
                                 subscriptionStatus === 'trialing' ||
                                 subscriptionStatus === 'past_due';

    const hasCloudStorage = isInOrganizationMode
        ? (currentOrganization?.subscription?.plan?.hasCloudStorage && isValidSubscription)
        : profile?.subscription?.hasCloudStorage;
    const hasFileShare = isInOrganizationMode
        ? (currentOrganization?.subscription?.plan?.hasFileShare && isValidSubscription)
        : profile?.subscription?.hasFileShare;

    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [fileToDelete, setFileToDelete] = useState(null);
    const [fileNameExist, setFileNameExist] = useState(false);

  const handleCheckHistory = (file) => {
    setSelectedFile(file)
    setModalVisible(true);
  };
    const handleDeleteClick = (fileName) => {
        setFileToDelete(fileName);
        setDeleteModalOpen(true);
    };
    const handleDeleteFile = async () => {
        if (!fileToDelete) return;

        try {

            // Call the delete API
            if (isInOrganizationMode && currentOrganization) {
                // Use organization delete endpoint
                await deleteOrganizationFile(token, currentOrganization.organizationUuid, selectedOperation.operation_id, fileToDelete);
            } else {
                // Use individual delete endpoint
                await deleteFile(token, userId, selectedOperation.operation_id, fileToDelete);
            }

            setAlert({
                open: true,
                message: 'File deleted successfully!',
                severity: 'success',
                buttonText: 'Close',
            });

            // Refresh file list
            fetchFiles();

            return true;
        } catch (error) {
            const errorMessage = "Failed to delete file";

            setAlert({
                open: true,
                message: errorMessage,
                severity: 'error',
                buttonText: 'Close',
            });

            return false;
        } finally {
            setDeleteModalOpen(false);
            setFileToDelete(null);
        }
    };

    useEffect(() => {
        const handleOffline = () => {
            setUploadState(prev => ({
            ...prev,
            message: "interrupted"
            }));
        };

        window.addEventListener("offline", handleOffline);
        
        return () => {
            window.removeEventListener("offline", handleOffline);
        };
        }, [setUploadState]); 


    const loadOperations = useCallback(async (currentFilters = {}, reset = false, order = "asc", status, includeNoAuthsParam = includeNoAuths) => {
        if (!status) {
            logger.warn("loadOperations called with undefined status.");
            return;
        }
        setLoading(true);
            try {
                // Pass organizationId for proper operation scoping
                const organizationId = currentOrganization?.organizationId || null;
                let newOperations = await getOperations(token, reset ? 1 : page, operationsPerPage, currentFilters, order, status, organizationId, includeNoAuthsParam);

                // AUTOMATED ROLE-BASED OPERATION FILTERING
                // Pilots can only see their own operations in the list
                if (isInOrganizationMode && userRole?.toLowerCase() === 'pilot' && userId) {
                    newOperations = newOperations.filter(operation => operation.user_id === userId);
                }
                // Viewers, Managers, Admins, Owners: No filtering - see all organization operations

                // Check if we received fewer operations than requested (indicates end of data)
                if (newOperations.length < operationsPerPage) {
                    setHasMoreOperations(false);
                } else {
                    setHasMoreOperations(true);
                }

                setDisplayedOperations(reset ? newOperations : (prevOperations) => [
                    ...prevOperations,
                    ...newOperations,
                ]);

            } catch (error) {
                logger.error("Error fetching operations:", error);
            } finally {
                setLoading(false);
            }
        }, [page, token, includeNoAuths, currentOrganization?.organizationId, isInOrganizationMode, userRole, userId]);
    
     
    useEffect(() => {
        window.Intercom('shutdown');// disable intercom chat
    }, []);


    useEffect(() => {
        if (displayedOperations.length === 0) return;

        if (highlightOperationId) {
            // If navigated from a submission, find and select that specific operation
            const match = displayedOperations.find(
                (op) => String(op.operation_id) === String(highlightOperationId)
            );
            if (match) {
                setSelectedOperation(match);
                return;
            }
        }
        // Default: select first operation
        setSelectedOperation(displayedOperations[0]);
    }, [displayedOperations, highlightOperationId]);

    // Main useEffect: Load operations when authentication/context is ready
    // NOTE: Filter handlers (handleApplyFilter, handleSortChange, etc.) already call
    // loadOperations directly, so this useEffect should NOT depend on filters/sort
    // to avoid duplicate API calls.
    useEffect(() => {
        // Only load if we have token and user context
        if (!token) {
            return;
        }

        // Wait for OrganizationContext to finish loading before making initial fetch
        if (contextLoading) {
            return;
        }

        if (!userId && !isInOrganizationMode) {
            return;
        }

        if (isInitialMount.current) {
            isInitialMount.current = false;
            loadOperations(filters, true, sortOrder, statusFilter);
        }
        // If not initial mount, this useEffect does nothing (handlers manage filter changes)
    }, [token, userId, isInOrganizationMode, currentOrganization, contextLoading]); // Depend on auth/context, NOT filters

    // Load more operations when page changes (infinite scroll pagination)
    useEffect(() => {
        // Don't load if it's the initial page, currently loading, or already loading more
        if (page === 1 || loading || isLoadingMoreRef.current) {
            return;
        }

        isLoadingMoreRef.current = true; // Mark as loading

        loadOperations(filters, false, sortOrder, statusFilter).finally(() => {
            // Clear the loading flag after a short delay to prevent immediate re-trigger
            setTimeout(() => {
                isLoadingMoreRef.current = false;
            }, 500);
        });
        //                      ^^^^^ reset=false to append data (not replace)
    }, [page]); // Only depend on page - filters/sort handled by main useEffect

    const fetchFiles = useCallback(async () => {
    if (!token || !selectedOperation?.id) return;

    try {
        let data;
        if (isInOrganizationMode && currentOrganization) {
            // Use organization files endpoint
            data = await getAllOrganizationFiles(token, currentOrganization.organizationUuid, selectedOperation.operation_id);
        } else {
            // Use individual files endpoint
            data = await getAllFiles(token, profile?.userId, selectedOperation.operation_id);
        }
        setFiles(data);
    } catch (error) {
        logger.error("[fetchFiles] Failed to fetch files:", error);
    } finally {
        setLoading(false);
    }
}, [token, selectedOperation, isInOrganizationMode, currentOrganization, profile]);


  
    useEffect(() => {
        fetchFiles();
      }, [fetchFiles]);

    useEffect(() => {
  let timer;
  if (message === "success" || message === "error") {
    timer = setTimeout(() => {
      setUploadState(prev => ({
        ...prev,
        showPanel: false,
        file: null,
        message: "",
        uploadProgress: 0
      }));
    }, 2000);
  }
  return () => clearTimeout(timer);
}, [message, setUploadState]);
    
  useEffect(() => {
    if (file) {
      setUploadState(prev => ({ ...prev, uploadStatus: null }));
    }
  }, [file, setUploadState]);
  
  useEffect(() => {
    if (message) {
      setUploadState(prev => ({ ...prev, uploadStatus: message }));
    }
  }, [message]);
      useEffect(() => {
            const fetchStorageAvailability = async () => {
            try {
                let response;
                if (isInOrganizationMode && currentOrganization) {
                    // Use organization storage endpoint
                    response = await checkOrganizationStorageAvailability(token, currentOrganization.organizationUuid);
                } else {
                    // Use individual storage endpoint
                    response = await checkStorageAvailability(token, userId);
                }

                // Validate response has required fields
                if (response.usedStorage === undefined || response.usedStorage === null) {
                    logger.error('[fetchStorageAvailability] usedStorage is missing from API response');
                    throw new Error('Invalid API response: usedStorage is missing');
                }

                if (response.storageLimit === undefined || response.storageLimit === null) {
                    logger.error('[fetchStorageAvailability] storageLimit is missing from API response');
                    throw new Error('Invalid API response: storageLimit is missing');
                }

                // Convert usedStorage from bytes to GB
                const usedGB = bytesToGB(response.usedStorage);

                // Detect if storageLimit is already in GB or bytes
                // If it's a large number (> 1000), it's likely in bytes
                // If it's a small number (< 1000), it's likely already in GB
                const totalGB = response.storageLimit > 1000
                    ? bytesToGB(response.storageLimit)  // Convert from bytes
                    : response.storageLimit;             // Already in GB

                // Validate converted values are valid numbers
                if (isNaN(usedGB) || isNaN(totalGB)) {
                    logger.error('[fetchStorageAvailability] Converted values are NaN', {
                        usedGB,
                        totalGB
                    });
                    throw new Error('Invalid storage values after conversion');
                }

                setUsedStorage(usedGB);
                setTotalStorage(totalGB);
                setStorage(response.hasAvailableSpace);
            } catch (err) {
                logger.error('Failed to fetch storage:', err);
                setUsedStorage(null);
                setTotalStorage(null);
                setStorage(false);
            }
            };

            if (token && (userId || (isInOrganizationMode && currentOrganization))) {
                fetchStorageAvailability();
            }
  }, [token, userId, isInOrganizationMode, currentOrganization]);

      const handleClose = () => {
        setAlert({ ...alert, open: false });
    };

      //filter handler methods
      const handleApplyFilter = (newFilters) => {
        setPage(1);
        setHasMoreOperations(true); // Reset pagination state
        isLoadingMoreRef.current = false; // Reset loading flag
        setFilters(newFilters);
        setDisplayedOperations([]);
        setShowMobileDetail(false); // Reset mobile detail view
        loadOperations(newFilters, true, sortOrder , statusFilter);
    };

    const handleSortChange = (order) => {
        setSortOrder(order);
        setPage(1);
        setHasMoreOperations(true); // Reset pagination state
        isLoadingMoreRef.current = false; // Reset loading flag
        setDisplayedOperations([]);
        setShowMobileDetail(false); // Reset mobile detail view
        loadOperations(filters, true, order ,statusFilter);
    };
    const handleStatusFilterChange = (newStatusFilter) => {
        setStatusFilter(newStatusFilter);
        setUserModifiedFilter(true); // Mark that user manually changed the filter
        setPage(1);
        setHasMoreOperations(true); // Reset pagination state
        isLoadingMoreRef.current = false; // Reset loading flag
        setDisplayedOperations([]);
        setShowMobileDetail(false); // Reset mobile detail view
        loadOperations(filters, true, sortOrder, newStatusFilter, includeNoAuths);
    };

    const handleIncludeNoAuthsChange = (checked) => {
        setIncludeNoAuths(checked);
        setPage(1);
        setHasMoreOperations(true); // Reset pagination state
        isLoadingMoreRef.current = false; // Reset loading flag
        setDisplayedOperations([]);
        setShowMobileDetail(false); // Reset mobile detail view
        loadOperations(filters, true, sortOrder, statusFilter, checked);
    };
    const handleRefresh = async () => {
        setRefreshing(true);
        setLoading(true);
        setDisplayedOperations([]);
        setPage(1);
        setHasMoreOperations(true); // Reset pagination state
        isLoadingMoreRef.current = false; // Reset loading flag
        setStartDate1(null);
        setStartDate2(null);
        setSortOrder("desc"); // Show newest operations first
        setFilters({});
        setUserModifiedFilter(false); // Reset manual filter flag
        setIncludeNoAuths(true); // Reset to default (include)
        setShowMobileDetail(false); // Reset mobile detail view
        // Default to all statuses to show all operations
        const defaultStatusFilter = ['Authorized', 'Pending', 'Complete', 'De-authorized', 'Deleted', 'Never Authorized', 'Invalid Detected', 'Rescinded Awaiting'];
        setStatusFilter(defaultStatusFilter);
        setTimeout(async () => {
        try {
        await loadOperations({}, true, "desc", defaultStatusFilter, true);
        } catch (error) {
            logger.error('Error refreshing operations log:', error);
            setAlert({
            open: true,
            message: 'Failed to refresh operations log.',
            title: 'Error',
            buttonText: 'Close'
            });
        }
        setLoading(false);
        setRefreshing(false);
        }, 500);
    };

      //operation handler methods

        const handleCancel = (authorizationId) => {
            const operationId = selectedOperation.operation_id;
            // console.log(operationId.replace(/^[^0-9]+/, ''));
            // console.log(authorizationId);
            // console.log(profile.userId);

            setSelectedAuthorizationId(authorizationId);
            setOpenModal(true);
        };
        
        const handleCancelOperation = async () => {
            try {
                //console.log("In handleCancelOperation");

                const operationId = selectedOperation.operation_id.replace(
                    /^[^0-9]+/,
                    ""
                );
                const authorizationId = selectedAuthorizationId;

                //console.log(profile.userId+""+ operationId + " " + authorizationId);

                await cancelAuthorization(token,profile.userId, operationId, authorizationId);

                //await cancelOperation(operationId);
                //alert(`Operation ${operationId} cancelled successfully`);
                setOpenModal(false);
                setSelectedOperation(null);
                setDisplayedOperations([]);
                setPage(1);
                await loadOperations(filters, true, sortOrder, statusFilter, includeNoAuths);
            } catch (error) {
                logger.error("Error cancelling operation:", error);
                setOpenModal(false);
                setAlert({
                    open: true,
                    message: "An error occurred while processing your request. Please try again later or contact support if the issue persists",
                    title: '',
                    buttonText: "Ok",
                });

            }
        };

        const handleDelete = (authorizationId) => {
            setSelectedAuthorizationId(authorizationId);
            setOpenDeleteModal(true);
        };

        const handleInvalidCancel = (authorizationId) => {
            setSelectedAuthorizationId(authorizationId);
            setOpenInvalidModal(true);
        };

        const handleInvalidCancelAcknowledge = async () => {
            try{
            const operationId = selectedOperation.operation_id.replace(/^[^0-9]+/, '');
            await ackInvalidCancelAuthorization(token,profile.userId, operationId, selectedAuthorizationId);
            setOpenInvalidModal(false);
            setSelectedOperation(null);
            setSelectedAuthorizationId(null);
            setDisplayedOperations([]);
            setPage(1);
            await loadOperations(filters, true, sortOrder, statusFilter, includeNoAuths);
            } catch (error) {
                setOpenInvalidModal(false);
                setAlert({
                    open: true,
                    message: "An error occurred while processing your request. Please try again later or contact support if the issue persists",
                    title: '',
                    buttonText: "Ok",
                });        
            }
        };


        const handleDeleteOperation = async () => {
        try {        
            // Extract numeric operationId
            const operationId = selectedOperation.operation_id.replace(/^[^0-9]+/, "");
            
            // Call delete authorization API
            await deleteAuthorization(
                token,
                profile.userId,
                operationId,
                selectedAuthorizationId
            );

            // Close the modal and reset state
            setOpenDeleteModal(false);
            setSelectedOperation(null);
            //setSelectedAuthorizationId(null);
            setDisplayedOperations([]);
            setPage(1);

            // Reload operations
            await loadOperations(filters, true, sortOrder, statusFilter, includeNoAuths);
            
        } catch (error) {
            setOpenDeleteModal(false);
            setAlert({
                open: true,
                message: "An error occurred while processing your request. Please try again later or contact support if the issue persists",
                title: '',
                buttonText: "Ok",
            });        
        }
    };


        const handleRescind = (authorizationId) => {
            setSelectedAuthorizationId(authorizationId);
            setOpenRescindModal(true);
        };

        const handleReschindedAcknowledge = async () => {
            try{
            //console.log(selectedOperation.operation_id + " " + selectedAuthorizationId);
            const operationId = selectedOperation.operation_id.replace(/^[^0-9]+/, "");

            await ackRescindAuthorization(
            token,
                profile.userId,
                operationId,
                selectedAuthorizationId
            );

            setOpenRescindModal(false);
            setSelectedOperation(null);
            setSelectedAuthorizationId(null);
            setDisplayedOperations([]);
            setPage(1);
            await loadOperations(filters, true, sortOrder, statusFilter, includeNoAuths);
        } catch (error) {
            setOpenRescindModal(false);
            setAlert({
                open: true,
                message: "An error occurred while processing your request. Please try again later or contact support if the issue persists",
                title: '',
                buttonText: "Ok",
            });        
        }
        };

        // Fetch drones for organization (for flight logging)
        const fetchDrones = useCallback(async () => {
            if (!isInOrganizationMode || !currentOrganization?.organizationUuid) {
                return;
            }

            try {
                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}/api/organization/${currentOrganization.organizationUuid}/drones`,
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

                if (response.ok) {
                    const data = await response.json();
                    setDrones(data.drones || []);
                }
            } catch (error) {
                logger.error('Error fetching drones:', error);
            }
        }, [isInOrganizationMode, currentOrganization, token]);

        // Fetch drones when in organization mode
        useEffect(() => {
            if (isInOrganizationMode && currentOrganization) {
                fetchDrones();
            }
        }, [isInOrganizationMode, currentOrganization, fetchDrones]);

        useEffect(() => {
            const handleScroll = () => {
                if (!scrollContainerRef.current) return;

                const scrollHeight = scrollContainerRef.current.scrollHeight;
                const scrollTop = scrollContainerRef.current.scrollTop;
                const clientHeight = scrollContainerRef.current.clientHeight;

                // Threshold: user must scroll within 50px of bottom to trigger
                const scrollThreshold = 50;
                const isNearBottom = scrollTop + clientHeight >= scrollHeight - scrollThreshold;

                // Only increment page if: near bottom, has more data, not loading, and not already loading more
                if (isNearBottom && hasMoreOperations && !loading && !isLoadingMoreRef.current) {
                    setPage((prevPage) => prevPage + 1);
                }
            };

            const scrollContainer = scrollContainerRef.current;
            scrollContainer?.addEventListener("scroll", handleScroll);

            return () => {
                scrollContainer?.removeEventListener("scroll", handleScroll);
            };
        }, [hasMoreOperations, loading]); // Fixed: proper dependencies

        const handleCardClick = (operation) => {
            setSelectedOperation(operation);
            // On mobile, show the detail view
            if (isMobile) {
                setShowMobileDetail(true);
            }
        };

        const handleBackToList = () => {
            setShowMobileDetail(false);
        };

        const handleCreateTemplate = (operation) => {
            setSelectedOperation(operation);
            setCreateTemplateDialogOpen(true);
        };

        // Handle viewing operation on map
        const handleViewOnMap = (operation) => {
            setMapViewOperation(operation);
            setMapViewDialogOpen(true);
        };

        // Handle logging a new flight for an operation
        const handleLogFlightHours = (operation) => {
            setSelectedOperation(operation);
            setEditingFlightLog(null);
            setLogFlightDialogOpen(true);
        };

        // Handle editing a specific existing flight log
        const handleEditFlightLog = (operation, flightLog) => {
            setSelectedOperation(operation);
            setEditingFlightLog(flightLog);
            setLogFlightDialogOpen(true);
        };

        // Patch flightLogs array in-place after create or update
        const patchOperationFlightLogs = (operationId, updatedLog, isNew) => {
            const applyPatch = (op) => {
                if (op.id !== operationId) return op;
                const logs = op.flightLogs || [];
                const newLogs = isNew
                    ? [updatedLog, ...logs]
                    : logs.map(l => l.id === updatedLog.id ? updatedLog : l);
                return { ...op, flightLogs: newLogs };
            };
            setDisplayedOperations(prev => prev.map(applyPatch));
            setSelectedOperation(prev => prev?.id === operationId ? applyPatch(prev) : prev);
        };

        const handleSubmitFlightLog = async (flightData) => {
            try {
                let result;

                if (editingFlightLog) {
                    // Edit mode — update existing flight log
                    result = await updateFlightLog(
                        token,
                        currentOrganization.organizationUuid,
                        editingFlightLog.id,
                        flightData
                    );
                    const updatedLog = result.flightLog;
                    patchOperationFlightLogs(selectedOperation.id, {
                        ...editingFlightLog,
                        flightDate: updatedLog?.flightDate ?? flightData.flightDate,
                        flightDuration: parseFloat(flightData.flightDuration),
                        location: flightData.location,
                        purpose: flightData.purpose,
                        notes: flightData.notes,
                        weatherConditions: flightData.weatherConditions,
                    }, false);
                } else {
                    // Create mode — add new flight log
                    result = await addFlightLog(token, currentOrganization.organizationUuid, flightData);
                    const createdLog = result.flightLog;
                    if (createdLog && selectedOperation) {
                        patchOperationFlightLogs(selectedOperation.id, {
                            id: createdLog.id,
                            flightDate: createdLog.flightDate,
                            flightDuration: parseFloat(createdLog.flightDuration),
                            location: createdLog.location,
                            purpose: createdLog.purpose,
                            notes: createdLog.notes,
                            weatherConditions: createdLog.weatherConditions,
                            drone: createdLog.drone ?? null,
                            pilot: createdLog.pilot ?? null,
                        }, true);
                    }
                }

                setLogFlightDialogOpen(false);
                setEditingFlightLog(null);
                setAlert({
                    open: true,
                    message: editingFlightLog
                        ? "Flight log updated successfully!"
                        : "Flight hours logged successfully!",
                    title: 'Success',
                    buttonText: "Ok",
                });
            } catch (error) {
                logger.error('Error submitting flight log:', error);
                throw error;
            }
        };

        const handleTemplateCreated = () => {
            setAlert({
                open: true,
                message: 'Operation template created successfully!',
                title: 'Success',
                buttonText: 'Close'
            });
            setCreateTemplateDialogOpen(false);
        };

        // Flight log deletion handlers
        const handleDeleteFlightLog = (operation, flightLog) => {
            setSelectedOperation(operation);
            setFlightLogToDelete(flightLog);
            setDeleteFlightLogModal(true);
        };

        const confirmDeleteFlightLog = async () => {
            try {
                if (!flightLogToDelete || !selectedOperation) return;

                await deleteFlightLog(
                    token,
                    currentOrganization.organizationUuid,
                    flightLogToDelete.id
                );

                // Remove the deleted log from the operation's flight logs
                const updatedFlightLogs = selectedOperation.flightLogs.filter(
                    log => log.id !== flightLogToDelete.id
                );

                // Update both displayed operations and selected operation
                setDisplayedOperations(prev =>
                    prev.map(op =>
                        op.id === selectedOperation.id
                            ? { ...op, flightLogs: updatedFlightLogs }
                            : op
                    )
                );

                setSelectedOperation(prev => ({
                    ...prev,
                    flightLogs: updatedFlightLogs
                }));

                setDeleteFlightLogModal(false);
                setFlightLogToDelete(null);

                setAlert({
                    open: true,
                    message: 'Flight log deleted successfully!',
                    title: 'Success',
                    buttonText: 'Ok',
                });
            } catch (error) {
                logger.error('Error deleting flight log:', error);
                setAlert({
                    open: true,
                    message: error.response?.data?.error || 'Failed to delete flight log',
                    title: 'Error',
                    buttonText: 'Ok',
                });
            }
        };

        const fetchExistingAssets = async () => {
            try {
                const assets = await getShareAssetUrls(userId);
                if (assets.bgUrl) {
                    setExistingBackground(assets.bgUrl);
                }
                if (assets.logoUrl) {
                    setExistingLogo(assets.logoUrl);
                }
            } catch (error) {
                logger.error('Error fetching existing assets:', error);
            }
        };


        const handleShareSubmit = async () => {
            if (!shareEmail || !selectedFile || !recipientName) {
                setAlert({
                    open: true,
                    message: 'Please fill all required fields',
                    title: 'Validation Error',
                    buttonText: 'Close'
                });
                return;
            }
            setShareLoading(true);

            try {
                // 1. Share the file first
                const shareResponse = await shareFile(
                    token,
                    selectedFile.fileId,
                    shareEmail,
                    recipientName,
                    profile.firstName,
                    profile.email,
                    selectedOperation.operation_id,
                    selectedFile.fileName,
                    selectedFile.fileType,

                );

               
                if (!shareResponse?.shareId) {
                    throw new Error('Failed to get share ID');
                }

                const shareId = shareResponse.shareId;

                // 2. Handle asset upload if both images exist
                if (logoImage || backgroundImage) {
                    try {
                        // Check if we have files for upload (background might be predefined URL)
                        const filesToUpload = [];
                        if (logoImageFile) filesToUpload.push('logo');
                        if (backgroundImageFile) filesToUpload.push('background');

                        let logoAssetKey = null;
                        let bgAssetKey = null;

                        if (filesToUpload.length > 0) {
                            // Get presigned URLs only for files we have
                            const { logoUploadUrl, bgUploadUrl, logoKey, bgKey } = await generatePresignedUrlsForCustomizationAssests(
                                token,
                                userId,
                                logoImageFile?.type,
                                backgroundImageFile?.type
                            );

                            logoAssetKey = logoKey;
                            bgAssetKey = bgKey;
                            
                            // Prepare upload promises
                            const uploadPromises = [];
                            if (logoImageFile) {
                                uploadPromises.push(
                                    axios.put(logoUploadUrl, logoImageFile, {
                                        headers: { 'Content-Type': logoImageFile.type }
                                    })
                                );
                            }
                            if (backgroundImageFile) {
                                uploadPromises.push(
                                    axios.put(bgUploadUrl, backgroundImageFile, {
                                        headers: { 'Content-Type': backgroundImageFile.type }
                                    })
                                );
                            }

                            // Execute uploads
                            await Promise.all(uploadPromises);

                            // Save uploads to DB after successful S3 upload
                            if (logoAssetKey || bgAssetKey) {
                                await saveUploadsDB(
                                    token,
                                    userId,
                                    logoAssetKey,
                                    bgAssetKey,
                                    logoImageFile?.type,
                                    backgroundImageFile?.type
                                );
                            }
                        }

                        setAlert({
                            open: true,
                            message: `File shared and customized successfully!`,
                            title: 'Success',
                            buttonText: 'Close'
                        });
                    } catch (uploadError) {
                        logger.error('Upload or DB save error:', uploadError);
                        setAlert({
                            open: true,
                            message: `File shared successfully, but customization failed`,
                            title: 'Partial Success',
                            buttonText: 'Close'
                        });
                    }
                } else {
                    setAlert({
                        open: true,
                        message: `File shared successfully!`,
                        title: 'Success',
                        buttonText: 'Close'
                    });
                }

                // Reset form
                setOpenShareModal(false);
                setShareEmail('');
                setLogoImage(null);
                setBackgroundImage(null);
                setSelectedFile(null);
                setRecipientName('');
            } catch (error) {
                let errorMessage;

                switch (error.message) {
                    case 'This file has been blocked due to policy violations':
                        errorMessage = 'This file is blocked due to policy violations.';
                        break;
                    case 'User has unsubscribed from emails. Please use another email address':
                        errorMessage = 'User has unsubscribed from emails. Please use another email address.';
                        break;
                    default:
                        errorMessage = error.response?.data?.message
                            ? `Something went wrong: ${error.response.data.message}`
                            : 'Failed to share file. Please try again.';
                }

                setAlert({
                    open: true,
                    message: errorMessage,
                    title: 'Error',
                    buttonText: 'Close'
                });
            } finally {
                setShareLoading(false);
            }
        };    
        const handleChooseFile = () => {
            fileInputRef.current.click();
        };

    const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    
    // Check if file was selected
    if (!selectedFile) {
        return;
    }

    // First check file size
    const maxFileSize = parseInt(process.env.REACT_S3_MAX_FILE_SIZE ) || 1024 * 1024 * 1024; // 1GB
    if (selectedFile.size > maxFileSize) {
        setAlert({
            open: true,
            message: `File sizes larger than ${bytesToMB(maxFileSize)}MB are not supported at the moment. For any questions, please contact support at support@flyzone.io.`,
            title: 'Warning',
            buttonText: 'Ok'
        });
        return;
    }

    // Define allowed file types
    const allowedTypes = [
        'application/pdf',
        'application/msword', // For .doc files
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // For .docx files
        'text/plain', // For .txt files
        // Image types
        'image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/tiff', 'image/webp',
        'image/heif', 'image/heic', 'image/avif', 'image/svg+xml', 'image/x-canon-cr2',
        'image/x-canon-cr3', 'image/x-nikon-nef', 'image/x-nikon-nrw', 'image/x-sony-arw',
        'image/x-sony-srf', 'image/x-sony-sr2', 'image/x-olympus-orf', 'image/x-panasonic-rw2',
        'image/x-adobe-dng', 'image/x-fuji-raf', 'image/x-pentax-pef', 'image/x-samsung-srw',
        'image/x-raw', 'image/x-adobe-dng',

        // Video types
        'video/mp4', 'video/x-m4v', 'video/quicktime', 'video/x-matroska', 'video/webm',
        'video/x-msvideo', 'video/x-flv', 'video/x-f4v', 'video/x-ms-wmv', 'video/x-ms-asf',
        'video/mp2t', 'video/MP2T', 'video/mts', 'video/m2ts', 'video/3gpp', 'video/3gpp2',
        'video/x-blackmagic-raw', 'video/x-red-r3d', 'video/x-adobe-dng', 'video/x-raw',

        // Audio types
        'audio/mpeg', 'audio/aac', 'audio/mp4', 'audio/x-m4a', 'audio/wav', 'audio/x-aiff',
        'audio/aiff', 'audio/flac', 'audio/x-alac', 'audio/ogg', 'audio/oga', 'audio/opus',
        'audio/x-ms-wma', 'audio/x-raw'
    ];

    // Check file type
    if (!allowedTypes.includes(selectedFile.type)) {
        setAlert({
            open: true,
            message: 'Only the following file types are allowed: PDF, DOC, DOCX, TXT, images (JPG, JPEG, PNG, GIF, BMP, TIF, TIFF, WEBP, HEIF, HEIC, AVIF, SVG, CR2, CR3, NEF, NRW, ARW, SRF, SR2, ORF, RW2, DNG, RAF, PEF, SRW, RAW, DNG), videos (MP4, M4V, MOV, MKV, WEBM, AVI, FLV, F4V, WMV, ASF, TS, MTS, M2TS, 3GP, 3G2, BRAW, R3D, DNG, RAW), and audio (MP3, AAC, M4A, WAV, AIFF, AIF, FLAC, ALAC, OGG, OGA, OPUS, WMA, RAW).',
            title: 'Error',
            buttonText: 'Close'
        });
        e.target.value = null;
        return;
    }

    try {
        // Check if file exists on the server
        let exists;
        if (isInOrganizationMode && currentOrganization) {
            // Use organization file check endpoint
            const existsValue = await checkOrganizationFileNameExists(token, currentOrganization.organizationUuid, selectedFile.name, selectedOperation.operation_id);
            exists = { exists: existsValue };
        } else {
            // Use individual file check endpoint
            exists = await checkFileNameExists(token, selectedOperation.operation_id, selectedFile.name, userId);
        }

        setFileNameExist(exists.exists);

        setUploadState(prev => ({
            ...prev,
            file: selectedFile,
            showPanel: true,
            uploadStatus: null,
            message: ""
        }));
    } catch (error) {
        logger.error("Error checking file existence:", error);
        setUploadState(prev => ({
            ...prev,
            uploadStatus: "error",
            message: "Error checking file existence",
        }));
        e.target.value = null;
    }
};

// Helper function to format file size

        const uploadChunkWithRetry = async (url, chunk, contentType, retries = 3) => {
        for (let attempt = 0; attempt < retries; attempt++) {
            try {
            return await axios.put(url, chunk, {
                headers: { 'Content-Type': contentType },
            });
            } catch (error) {
            if (attempt === retries - 1) throw error;
            logger.warn(`Retrying chunk (attempt ${attempt + 1})...`);
            }
        }
        };

        const handleUpload = async () => {
            if (!file) return;

            // Check if this specific file fits in available storage (prioritize actual numbers over flag)
            if (usedStorage !== null && usedStorage !== undefined &&
                totalStorage !== null && totalStorage !== undefined &&
                !isNaN(usedStorage) && !isNaN(totalStorage)) {

                const availableStorageGB = totalStorage - usedStorage; // In GB
                const fileSizeInMB = bytesToMB(file.size);
                const availableStorageMB = availableStorageGB * 1024; // Convert GB to MB

                if (fileSizeInMB > availableStorageMB) {
                    setUploadState(prev => ({
                    ...prev,
                    showPanel: false,
                    }));
                    setAlert({
                    open: true,
                    message: `Not enough storage available to upload this file. You need ${fileSizeInMB.toFixed(2)} MB but only have ${availableStorageMB.toFixed(2)} MB available.`,
                    title: 'Error',
                    buttonText: 'Close',
                    });
                    return;
                }
            } else {
                // Storage numbers not available, check backend flag
                if (!hasStorage) {
                    setUploadState(prev => ({
                    ...prev,
                    showPanel: false,
                    }));
                    setAlert({
                    open: true,
                    message: 'Not enough storage available to upload this file. Please check your subscription plan.',
                    title: 'Error',
                    buttonText: 'Close',
                    });
                    return;
                }
            }

            setUploadState(prev => ({
                ...prev,
                uploading: true,
                uploadProgress: 0,
                message: '',
            }));

            let response;
            let existingParts = [];

            try {
                if (isInOrganizationMode && currentOrganization) {
                    // Use organization upload endpoint
                    logger.log('[handleUpload] Requesting organization presigned URL');
                    response = await generateOrganizationPresignUrl(token, file.name, file.size, file.type, currentOrganization.organizationUuid, selectedOperation.operation_id);
                    logger.log('[handleUpload] Organization presigned URL response:', response);
                } else {
                    // Use individual upload endpoint
                    logger.log('[handleUpload] Requesting individual presigned URL');
                    response = await generatePresignUrl(token, file.name, file.size, file.type, userId, selectedOperation.operation_id);
                    logger.log('[handleUpload] Individual presigned URL response:', response);
                }
                const { fileId, isMultipart, uploadId, partUrls, existingParts: prevParts } = response;
                file.uploadId = uploadId;

                if (isMultipart && partUrls && uploadId) {
                if (prevParts) {
                    existingParts = prevParts;
                    const uploadedSize = existingParts.reduce((sum, part) => sum + part.Size, 0);
                    const initialProgress = (uploadedSize / file.size) * 100;
                    setUploadState(prev => ({
                    ...prev,
                    uploadProgress: Math.round(initialProgress),
                    }));
                }

                const chunkSize = process.env.REACT_APP_UPLOAD_CHUNK_SIZE ? parseInt(process.env.REACT_APP_UPLOAD_CHUNK_SIZE) : 5 * 1024 * 1024;
                logger.log(`Chunk size set to: ${chunkSize} bytes`);
                const chunkCount = Math.ceil(file.size / chunkSize);
                let totalUploaded = existingParts.reduce((sum, part) => sum + part.Size, 0);
                const parts = [...existingParts];

                for (let i = 0; i < chunkCount; i++) {
                    if (existingParts.some(part => part.PartNumber === i + 1)) continue;

                    const start = i * chunkSize;
                    const end = Math.min(start + chunkSize, file.size);
                    const chunk = file.slice(start, end);
                    const partUrl = partUrls.find(p => p.partNumber === i + 1)?.url;
                    if (!partUrl) throw new Error('Missing part URL');

                    try {
                    const res = await uploadChunkWithRetry(partUrl, chunk, file.type);
                    parts.push({
                        PartNumber: i + 1,
                        ETag: res.headers.etag,
                    });
                    totalUploaded += chunk.size;

                    const percent = Math.round((totalUploaded / file.size) * 100);
                    setUploadState(prev => ({
                        ...prev,
                        uploadProgress: Math.min(99, percent),
                    }));
                    } catch (error) {
                    logger.error(error);
                    if (error.response?.status === 408 || error.code === 'ECONNABORTED') {
                        setUploadState(prev => ({
                        ...prev,
                        message: 'interrupted',
                        uploadStatus: 'interrupted',
                        }));
                        return;
                    } else {
                        throw error;
                    }
                    }
                }

                logger.log('[handleUpload] Completing multipart upload with', parts.length, 'parts');
                if (isInOrganizationMode && currentOrganization) {
                    // Use organization complete multipart endpoint
                    logger.log('[handleUpload] Calling organization complete multipart');
                    await completeOrganizationMultipartUpload(token, currentOrganization.organizationUuid, selectedOperation.operation_id, file.name, uploadId, parts);
                    logger.log('[handleUpload] Organization multipart upload completed successfully');
                } else {
                    // Use individual complete multipart endpoint
                    logger.log('[handleUpload] Calling individual complete multipart');
                    await completeMultipartUpload(token, selectedOperation.operation_id, file.name, userId, uploadId, parts);
                    logger.log('[handleUpload] Individual multipart upload completed successfully');
                }
                } else {
                // Fallback for simple upload (simulate progress)
                setUploadState(prev => ({ ...prev, uploadProgress: 5 }));
                await new Promise((resolve, reject) => {
                    const interval = setInterval(() => {
                    setUploadState(prev => {
                        const next = Math.min(95, prev.uploadProgress + 5);
                        return { ...prev, uploadProgress: next };
                    });
                    }, 300);

                    axios
                    .put(response.presignedUrl, file, {
                        headers: { 'Content-Type': file.type },
                    })
                    .then(() => {
                        clearInterval(interval);
                        resolve();
                    })
                    .catch(error => {
                        clearInterval(interval);
                        reject(error);
                    });
                });
                }

                // Save file metadata for both individual and organization files
                // This enables features like file sharing that require database records
                const organizationId = isInOrganizationMode && currentOrganization ? currentOrganization.organizationId : null;
                logger.log('[handleUpload] Saving file metadata to database', { isInOrganizationMode, organizationId });
                await saveFileMetadata(token, fileId, file.name, file.size, file.type, userId, selectedOperation.id, organizationId);

                logger.log('[handleUpload] Upload completed successfully, updating UI state');
                setUploadState(prev => ({
                ...prev,
                message: 'success',
                uploadProgress: 100,
                uploadStatus: 'completed',
                }));
                setUsedStorage(prev => (prev !== null ? prev + bytesToGB(file.size) : null));
                if (onFileUpload) onFileUpload(fileId);

                logger.log('[handleUpload] Calling fetchFiles to refresh file list');
                fetchFiles();
            } catch (error) {
                logger.error('Upload error:', error);
                if (error.response?.status === 408 || error.code === 'ECONNABORTED') {
                setUploadState(prev => ({
                    ...prev,
                    message: 'interrupted',
                    uploadStatus: 'interrupted',
                }));
                } else {
                setUploadState(prev => ({
                    ...prev,
                    message: 'error',
                    uploadStatus: 'failed',
                    failedUploads: [...prev.failedUploads, file.name],
                }));

                if (response?.isMultipart && response?.uploadId) {
                    try {
                    if (isInOrganizationMode && currentOrganization) {
                        // Use organization abort multipart endpoint
                        await abortOrganizationMultipartUpload(token, currentOrganization.organizationUuid, selectedOperation.operation_id, file.name, response.uploadId);
                    } else {
                        // Use individual abort multipart endpoint
                        await abortMultipartUpload(token, response.fileId, userId, response.uploadId, selectedOperation.operation_id, file.name);
                    }
                    } catch (abortError) {
                    logger.error('Error aborting multipart upload:', abortError);
                    }
                }
                }
            } finally {
                setUploadState(prev => ({ ...prev, uploading: false }));
            }
            };


        const handleCancelFile = () => {
            setUploadState(prev => ({
            ...prev,
            file: null,
            showPanel: false,
            message: "",
            uploadProgress: 0
            }));
        };

    const handleDownload = async (file) => {
        try {
            let url;
            if (isInOrganizationMode && currentOrganization) {
                // Use organization download endpoint
                url = await getOrganizationDownloadUrl(token, currentOrganization.organizationUuid, file.fileName, file.fileType, selectedOperation.operation_id);
            } else {
                // Use individual download endpoint
                url = await getDownloadUrl(token, file?.fileId, profile.userId, selectedOperation.operation_id, file.fileName, file.fileType);
            }
            window.open(url, "_blank");
        } catch (error) {
            if (error.message === "File not found") {
                setAlert({
                    open: true,
                    message: 'The file you are trying to download could not be found.',
                    title: 'File Not Found',
                    buttonText: 'Close',
                });
            } else if (error.message === "This file has been blocked due to policy violations") {
                setAlert({
                    open: true,
                    message: 'This file has been blocked due to policy violations and cannot be downloaded.',
                    title: 'File Blocked',
                    buttonText: 'Close',
                });
            } else {
                setAlert({
                    open: true,
                    message: 'Failed to download the file. Please try again later.',
                    title: 'Download Error',
                    buttonText: 'Close',
                });
            }
            logger.error('Download error:', error);
        }
    };
    
          const handleShare = (file) => {
            setSelectedFile(file)
            setOpenShareModal(true);
        };
    
    return (
        <>
            {authenticated === false ? (
                <Container maxWidth="xl" sx={{ py: 4 }}>
                    <Box className={MissionLogStyles.box_container_warning}>
                        <Box className={MissionLogStyles.box_container_message}>
                            <h2>Please log in to access your operations log</h2>
                        </Box>
                    </Box>
                </Container>
            ) : (
                <>
                    {authenticated === true ? (
                        <>
                        <PopupAlert 
                        open={alert.open} 
                        handleClose={handleClose} 
                        message={alert.message} 
                        title={alert.title} 
                        buttonText={alert.buttonText} 
                    />


                        <Container maxWidth="xl" sx={{ py: { xs: 2, sm: 3, md: 4 }, px: { xs: 1, sm: 2, md: 3 } }}>
                            <div>

                            <div className={MissionLogStyles.title_container}>
                            <Grid container spacing={2} alignItems="center">
                              <Grid item xs={12} sm={6}>
                                <Typography
                                  variant="h6"
                                  component="h6"
                                  className={MissionLogStyles.MissionLog_typography_title__97hWd}
                                  sx={{
                                    fontSize: { xs: '1.25rem', sm: '1.5rem', md: '2rem' }
                                  }}
                                >
                                  Operations Log
                                </Typography>
                              </Grid>

                              <Grid item xs={12} sm={6} container justifyContent={{ xs: 'flex-start', sm: 'flex-end' }}>
                                <Button
                                  variant="contained"
                                  onClick={handleRefresh}
                                  className={MissionLogStyles.refresh_button}
                                  disabled={refresh}
                                  startIcon={refresh ? <CircularProgress size={24} color="inherit" /> : <RefreshIcon />}
                                  fullWidth={isMobile}
                                  sx={{
                                    fontSize: { xs: '0.813rem', sm: '0.875rem' },
                                    padding: { xs: '8px 12px', sm: '6px 16px' }
                                  }}
                                >
                                  {refresh ? "Refreshing..." : (isMobile ? "Refresh" : "Refresh Operations Log")}
                                </Button>
                              </Grid>

                              <Grid item xs={12}>
                                <MissionLogFilter
                                  startDate1={startDate1}
                                  setStartDate1={setStartDate1}
                                  startDate2={startDate2}
                                  setStartDate2={setStartDate2}
                                  onApplyFilter={handleApplyFilter}
                                  sortOrder={sortOrder}
                                  setSortOrder={handleSortChange}
                                  onStatusFilterChange={handleStatusFilterChange}
                                  statusFilter={statusFilter}
                                  setStatusFilter={setStatusFilter}
                                  includeNoAuths={includeNoAuths}
                                  onIncludeNoAuthsChange={handleIncludeNoAuthsChange}
                                />
                              </Grid>
                            </Grid>
                          </div>

                                    {loading && (
                                        <Box
                                          className={MissionLogStyles.loadingOverlay}
                                        >
                                          <CircularProgress size={50} color="primary" />
                                          <Typography variant="h6" color="white" marginLeft={2}>
                                            Loading Operations Log...
                                          </Typography>
                                        </Box>
                                      )}
                                { displayedOperations.length > 0 ? (
                                <div container className={MissionLogStyles.missionmap_details}>
                                    {/* Operations List - Hidden on mobile when detail view is shown */}
                                    {(!isMobile || !showMobileDetail) && (
                                        <div
                                            ref={scrollContainerRef}
                                            className={`${MissionLogStyles.missionmap_location_list}  ${
                                                isSmallScreen ? "small-screen" : ""
                                            }`}
                                        >
                                        {displayedOperations.map((operation, index) => (
                                            <div key={`${operation.operation_id}_${index}`}>
                                                <OperationCardComponent
                                                    operation={operation}
                                                    onClick={() => handleCardClick(operation)}
                                                    isSelected={
                                                        selectedOperation &&
                                                        selectedOperation.operation_id === operation.operation_id
                                                    }
                                                />
                                            </div>
                                        ))}

                                        {/* Loading indicator for pagination */}
                                        {loading && page > 1 && (
                                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 2, gap: 1 }}>
                                                <CircularProgress size={24} />
                                                <Typography variant="body2" color="text.secondary">
                                                    Loading more operations...
                                                </Typography>
                                            </Box>
                                        )}

                                        {/* End of data indicator */}
                                        {!hasMoreOperations && displayedOperations.length > 0 && !loading && (
                                            <Box sx={{ textAlign: 'center', p: 2 }}>
                                                <Typography variant="body2" color="text.secondary">
                                                    All operations loaded ({displayedOperations.length} total)
                                                </Typography>
                                            </Box>
                                        )}

                                        </div>
                                    )}

                                    {/* Operation Summary - Full screen on mobile when detail view is shown */}
                                    {(!isMobile || showMobileDetail) && (
                                        <div
                                            className={`${MissionLogStyles.missionmap_summary} ${
                                                isSmallScreen ? "small-screen" : ""
                                            } ${isMobile && showMobileDetail ? MissionLogStyles.mobile_detail_view : ""}`}
                                        >
                                            {/* Mobile Back Button */}
                                            {isMobile && showMobileDetail && (
                                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, borderBottom: '1px solid #E0E0E0', pb: 2 }}>
                                                    <IconButton
                                                        onClick={handleBackToList}
                                                        sx={{ mr: 1 }}
                                                    >
                                                        <ArrowBackIcon />
                                                    </IconButton>
                                                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                                        Back to Operations
                                                    </Typography>
                                                </Box>
                                            )}

                                            <Typography
                                                variant="p"
                                                mt={isMobile && showMobileDetail ? 0 : 2}
                                                component="p"
                                                className={MissionLogStyles.missionmap_summary_title}
                                            >
                                                Operation Summary
                                            </Typography>

                                        {selectedOperation && (() => {
                                            const canLogFlight = isInOrganizationMode && hasPermission(userRole, 'LOG_FLIGHT_HOURS');
                                            return (
                                            <MoreDetailsComponent
                                                operation={selectedOperation}
                                                files={files}
                                                handleDownload={handleDownload}
                                                handleShare={handleShare}
                                                handleCheckHistory={handleCheckHistory}
                                                handleDeleteClick={handleDeleteClick}
                                                handleCancel={handleCancel}
                                                handleDelete={handleDelete}
                                                handleRescind={handleRescind}
                                                handleInvalidCancel={handleInvalidCancel}
                                                handleCreateTemplate={handleCreateTemplate}
                                                handleLogFlightHours={canLogFlight ? handleLogFlightHours : null}
                                                handleEditFlightLog={canLogFlight ? handleEditFlightLog : null}
                                                handleDeleteFlightLog={canLogFlight ? handleDeleteFlightLog : null}
                                                handleViewOnMap={handleViewOnMap}
                                                file={file}
                                                uploading={uploading}
                                                uploadProgress={uploadProgress}
                                                message={message}
                                                showPanel={showPanel}
                                                failedUploads={failedUploads}
                                                onChooseFile={handleChooseFile}
                                                onFileChange={handleFileChange}
                                                onUpload={handleUpload}
                                                onCancel={handleCancelFile}
                                                fileInputRef={fileInputRef}
                                                usedStorage={usedStorage}
                                                totalStorage={totalStorage}
                                                hasCloudStorage={hasCloudStorage}
                                                hasFileShare={hasFileShare}
                                                fileNameExist={fileNameExist}
                                                userRole={userRole}
                                                isInOrganizationMode={isInOrganizationMode}
                                                userId={userId}
                                                currentUserProfile={profile}
                                                canCreateTemplate={!isInOrganizationMode || isValidSubscription}
                                            />
                                            );
                                        })()}
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <Typography variant="h8" component="h4" className={MissionLogStyles.no_operations_message}>
                                    No operations to show
                                </Typography>
                            )}
                            </div>
                            <SharedHistoryModal
                                fileId={selectedFile?.fileId}
                                open={modalVisible}
                                onClose={() => setModalVisible(false)}
                                token={token}
                                userId={profile?.userId}
                            />
                            <Modal
                                open={openModal}
                                onClose={() => setOpenModal(false)}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: 500,
                                        bgcolor: "background.paper",
                                        boxShadow: 24,
                                        p: 3,
                                        borderRadius: 2,
                                        outline: "none",
                                    }}
                                >
                                    <Typography
                                        id="modal-modal-title"
                                        variant="subtitle1"
                                        component="h2"
                                    >
                                        Are you sure you want to cancel the{" "}FLZ
                                        <span className={MissionLogStyles.operation_id}>
                      {selectedAuthorizationId}
                    </span>{" "}
                                        operation?
                                    </Typography>
                                    <Grid container mt={2} spacing={2}>
                                        <Grid item xs={6}>
                                            <Button
                                                variant="outlined"
                                                color="error"
                                                fullWidth
                                                onClick={() => setOpenModal(false)}
                                            >
                                                No
                                            </Button>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Button
                                                variant="contained"
                                                className={MissionLogStyles.yes_button}
                                                fullWidth
                                                onClick={handleCancelOperation}
                                            >
                                                Yes
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Modal>

                            <Modal
                                open={openDeleteModal}
                                onClose={() => setOpenDeleteModal(false)}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: 500,
                                        bgcolor: "background.paper",
                                        boxShadow: 24,
                                        p: 3,
                                        borderRadius: 2,
                                        outline: "none",
                                    }}
                                >
                                    <Typography
                                        id="modal-modal-title"
                                        variant="subtitle1"
                                        component="h2"
                                    >
                                        Are you sure you want to delete the{" "}FLZ
                                        <span className={MissionLogStyles.operation_id}>
                      {selectedAuthorizationId}
                    </span>{" "}
                                        operation?
                                    </Typography>
                                    <Grid container mt={2} spacing={2}>
                                        <Grid item xs={6}>
                                            <Button
                                                variant="outlined"
                                                color="error"
                                                fullWidth
                                                onClick={() => setOpenDeleteModal(false)}
                                            >
                                                No
                                            </Button>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Button
                                                variant="contained"
                                                className={MissionLogStyles.yes_button}
                                                fullWidth
                                                onClick={handleDeleteOperation}
                                            >
                                                Yes
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Modal>

                            <Modal
                                open={openRescindModal}
                                onClose={() => setOpenRescindModal(false)}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: 500,
                                        bgcolor: "background.paper",
                                        boxShadow: 24,
                                        p: 3,
                                        borderRadius: 2,
                                        outline: "none",
                                    }}
                                >
                                    <Typography
                                        id="modal-modal-title"
                                        variant="subtitle1"
                                        component="h2"
                                    >
                                        You are acknowledging rescinded authorization{" "}
                                        <span className={MissionLogStyles.operation_id}>
                      {selectedAuthorizationId}
                    </span>{" "}
                                        operation?
                                    </Typography>
                                    <Grid container mt={2} spacing={2}>
                                        <Grid item xs={6}>
                                            <Button
                                                variant="outlined"
                                                color="error"
                                                fullWidth
                                                onClick={() => setOpenRescindModal(false)}
                                            >
                                                No
                                            </Button>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Button
                                                variant="contained"
                                                className={MissionLogStyles.yes_button}
                                                fullWidth
                                                onClick={handleReschindedAcknowledge}
                                            >
                                                Yes
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Modal>

                            <Modal
                                open={openInvalidModal}
                                onClose={() => setOpenInvalidModal(false)}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: 500,
                                        bgcolor: "background.paper",
                                        boxShadow: 24,
                                        p: 3,
                                        borderRadius: 2,
                                        outline: "none",
                                    }}
                                >
                                    <Typography
                                        id="modal-modal-title"
                                        variant="subtitle1"
                                        component="h2"
                                    >
                                        You are acknowledging an invalid authorization{" "}
                                        <span className={MissionLogStyles.operation_id}>
                      {selectedAuthorizationId}
                    </span>{" "}
                                        operation?
                                    </Typography>
                                    <Grid container mt={2} spacing={2}>
                                        <Grid item xs={6}>
                                            <Button
                                                variant="outlined"
                                                color="error"
                                                fullWidth
                                                onClick={() => setOpenInvalidModal(false)}
                                            >
                                                No
                                            </Button>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Button
                                                variant="contained"
                                                className={MissionLogStyles.yes_button}
                                                fullWidth
                                                onClick={handleInvalidCancelAcknowledge}
                                            >
                                                Yes
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Modal>
                                    <ConfirmationModal
                                        open={deleteModalOpen}
                                        onClose={() => {
                                            setDeleteModalOpen(false);
                                            setFileToDelete(null);
                                        }}
                                        title="Confirm File Deletion"
                                        content={`Are you sure you want to delete this file? This action cannot be undone.`}
                                        confirmText="Delete"
                                        cancelText="Cancel"
                                        onConfirm={handleDeleteFile}

                                    />

<ShareModal
                open={openShareModal}
                onClose={() => setOpenShareModal(false)}
                recipientName={recipientName}
                setRecipientName={setRecipientName}
                shareEmail={shareEmail}
                setShareEmail={setShareEmail}
                handleShareSubmit={handleShareSubmit}
                shareLoading={shareLoading}
                backgroundImage={backgroundImage}
                setBackgroundImage={setBackgroundImage}
                logoImage={logoImage}
                setLogoImage={setLogoImage}
                setLogoImageFile={setLogoImageFile}
                setBackgroundImageFile={setBackgroundImageFile}
                subscriptionType={subscriptionType}
                existingBackgroundImage={existingBackground}
                existingLogoImage={existingLogo}
                fetchExistingUrl={fetchExistingAssets}
            />

            <CreateTemplateDialog
                open={createTemplateDialogOpen}
                onClose={() => setCreateTemplateDialogOpen(false)}
                operation={selectedOperation}
                onSuccess={handleTemplateCreated}
            />

            <LogFlightDialog
                open={logFlightDialogOpen}
                onClose={() => {
                    setLogFlightDialogOpen(false);
                    setEditingFlightLog(null);
                }}
                onSubmit={handleSubmitFlightLog}
                drones={drones}
                operation={selectedOperation}
                flightLog={editingFlightLog}
                pilotName={selectedOperation?.operator_name}
                pilotId={selectedOperation?.user_id}
                currentUserId={profile?.id}
            />

            <MapViewDialog
                open={mapViewDialogOpen}
                onClose={() => {
                    setMapViewDialogOpen(false);
                    setMapViewOperation(null);
                }}
                operationId={mapViewOperation?.id}
                operationName={mapViewOperation ? `FLZ${mapViewOperation.operation_id}` : null}
            />

            {/* Delete Flight Log Confirmation Modal */}
            <Modal
                open={deleteFlightLogModal}
                onClose={() => {
                    setDeleteFlightLogModal(false);
                    setFlightLogToDelete(null);
                }}
                aria-labelledby="delete-flight-log-modal"
            >
                <Box className={MissionLogStyles.modal_container}>
                    <Box className={MissionLogStyles.modal_content}>
                        <Typography
                            variant="h6"
                            className={MissionLogStyles.modal_title}
                        >
                            Delete Flight Log
                        </Typography>
                        <Typography className={MissionLogStyles.modal_message}>
                            Are you sure you want to delete this flight log?
                            {flightLogToDelete && (
                                <Box sx={{ mt: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                                    <Typography variant="body2">
                                        <strong>Date:</strong> {flightLogToDelete.flightDate && new Date(flightLogToDelete.flightDate).toLocaleDateString()}
                                    </Typography>
                                    <Typography variant="body2">
                                        <strong>Duration:</strong> {flightLogToDelete.flightDuration}h
                                    </Typography>
                                    {flightLogToDelete.pilot && (
                                        <Typography variant="body2">
                                            <strong>Pilot:</strong> {flightLogToDelete.pilot.firstName} {flightLogToDelete.pilot.lastName}
                                        </Typography>
                                    )}
                                </Box>
                            )}
                            <br /><br />
                            This action cannot be undone.
                        </Typography>
                        <Grid container spacing={2} sx={{ mt: 2 }}>
                            <Grid item xs={6}>
                                <Button
                                    variant="outlined"
                                    className={MissionLogStyles.no_button}
                                    fullWidth
                                    onClick={() => {
                                        setDeleteFlightLogModal(false);
                                        setFlightLogToDelete(null);
                                    }}
                                >
                                    Cancel
                                </Button>
                            </Grid>
                            <Grid item xs={6}>
                                <Button
                                    variant="contained"
                                    className={MissionLogStyles.yes_button}
                                    fullWidth
                                    onClick={confirmDeleteFlightLog}
                                >
                                    Delete
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Modal>

                        </Container>

                        </>
                    ) : null}
                </>
            )}
        </>
    );
};

export default MissionLog;
